import * as ko from 'knockout'
import type { IObservableFinisher } from '../../../Model/Observables/IObservableFinisher'
import { FinisherPlaceViewModel } from './FinisherPlaceViewModel'
import template from './finisher.place.tpl.html'

if (!ko.components.isRegistered('finisher-place')) {
  ko.components.register('finisher-place', {
    viewModel: {
      createViewModel: (params: { finisher: IObservableFinisher }) => {
        const viewModel = new FinisherPlaceViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
